import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6f08814"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layer-modifiers" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "modifier-button handle" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "modifier-icon modifier-icon--grip fas fa-grip-lines" })
  ])
], -1))
const _hoisted_2 = { class: "layer-modifiers" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "modifier-icon fas fa-chevron-down"
}
const _hoisted_5 = {
  key: 1,
  class: "modifier-icon fas fa-chevron-right"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "layer-modifiers" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "modifier-icon fas fa-copy" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmingButton = _resolveComponent("ConfirmingButton")!
  const _component_LayersPanelLayer = _resolveComponent("LayersPanelLayer", true)!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createBlock(_component_draggable, {
    class: "dragArea list-group w-full",
    list: _ctx.layers,
    onChange: _ctx.log,
    group: { name: 'g1' },
    handle: ".handle"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layers, (layer, layerIndex) => {
        return (_openBlock(), _createElementBlock("div", { key: layer }, [
          _createElementVNode("div", {
            class: _normalizeClass(["layer", { selected: _ctx.isSelected(layer) }])
          }, [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                style: _normalizeStyle(_ctx.padderStyle)
              }, null, 4),
              (layer && layer.type === 'group')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "modifier-button small",
                    onClick: ($event: any) => (_ctx.setVisibility(layerIndex))
                  }, [
                    (_ctx.isOpen(layerIndex))
                      ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                      : _createCommentVNode("", true),
                    (!_ctx.isOpen(layerIndex))
                      ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_3))
                : _createCommentVNode("", true)
            ]),
            (_ctx.depth >= 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "layer-name-container",
                  onClick: ($event: any) => (_ctx.toggleSelect({ layer, event: $event }))
                }, _toDisplayString(layer.name), 9, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ConfirmingButton, {
                "onUpdate:callback": () => _ctx.copy(layer),
                class: "modifier-button"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onUpdate:callback"])
            ])
          ], 2),
          (layer && layer.type === 'group' && _ctx.isOpen(layerIndex))
            ? (_openBlock(), _createBlock(_component_LayersPanelLayer, {
                key: 0,
                class: "child-container",
                layers: layer.layers,
                depth: _ctx.depth + 1,
                onToggleSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSelect($event))),
                selectedLayers: _ctx.selectedLayers
              }, null, 8, ["layers", "depth", "selectedLayers"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["list", "onChange"]))
}